import { Box, makeStyles } from '@material-ui/core';
import { FunctionComponent } from 'react';

type Props = {
  testId: string;
};

export const PageContainer: FunctionComponent<Props> = (props) => {
  const classes = useStyles();
  return (
    <Box className={classes.root} data-testid={props.testId}>
      {props.children}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    [theme.breakpoints.up('lg')]: {
      padding: '0 60px',
    },
  },
}));
